import { render, staticRenderFns } from "./OurDepartments.vue?vue&type=template&id=70afc5d6&scoped=true&"
import script from "./OurDepartments.vue?vue&type=script&lang=js&"
export * from "./OurDepartments.vue?vue&type=script&lang=js&"
import style0 from "./OurDepartments.vue?vue&type=style&index=0&id=70afc5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afc5d6",
  null
  
)

export default component.exports